import { Modal } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import PrescriptionDetails from "../../../../ConsultationNotes/VitalTabs/ViewPrescription/PrescriptionDetails";
import Preview from "../../../../../../Assets/Images/Svg/PreviewIcon.svg";

function PrescriptionCard({ prescription, key }) {
  const [prescViewMod, setPrescViewMod] = useState(false);
  const { selectedRpmPatient } = useSelector((state) => state.rpm);

  const handlView = () => {
    setPrescViewMod(!prescViewMod);
  };

  return (
    <div key={key}>
      <div className="bg-white shadow rounded-xl border mb-4">
        <div className="flex items-center justify-between p-3 border-b">
          <span className="text-xs font-sans text-[#333333] font-semibold">
            APT-{prescription.appointmentId}
          </span>
          <button
            className="bg-white"
            onClick={handlView}
            // className="w-28 h-6 bg-brand-primaryColor text-white font-sans font-medium text-xs rounded-md"
          >
            <img src={Preview} alt="" className="w-6 h-6" role="button" />
          </button>
        </div>
        <div className="p-3 space-y-2">
          <div className="flex items-center gap-2">
            <span className="text-xs font-medium font-sans text-[#333333]">
              {prescription.userName}
            </span>
          </div>
          <div className="text-xs font-medium font-sans text-[#333333]">
            <span className="text-xs font-medium font-sans text-[#828282]">
              Reason:
            </span>{" "}
            {prescription.consultationReason}
          </div>
          <div className="flex gap-5 pt-2 border-t">
            <span className="flex items-center mt-1 justify-center rounded-md gap-2 text-xs font-medium font-sans text-[#333333] bg-[#D1FDDB] w-24 h-5">
              {prescription.clinic_Name}
            </span>
            <span className="border-l-2 border"></span>
            <span className="flex items-center gap-2 text-xs font-medium font-sans text-[#333333]">
              {prescription.consultationDate}
            </span>
          </div>
        </div>
      </div>

      {/* View Prescription */}
      <Modal
        open={prescViewMod}
        onCancel={handlView}
        footer={[]}
        width={"70%"}
        destroyOnClose
      >
        <PrescriptionDetails
          prescription={prescription}
          selectedPatient={selectedRpmPatient}
        />
      </Modal>
    </div>
  );
}

export default PrescriptionCard;
